import { CommonModule } from '@angular/common';
import { DOCUMENT } from '@angular/core';
import { domainInfoToHostName, getCurrentDomainInfo, SafeHtmlPipe } from '@core/frontend-shared/utils';
import '@core/shared/types/webpack-loaders';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/common";
const _c0 = (a0, a1, a2, a3, a4, a5) => ({
  "background": a0,
  "outline": a1,
  "quad": a2,
  "match-height": a3,
  "match-width": a4,
  "default": a5
});
export let UiLogoComponent = /*#__PURE__*/(() => {
  class UiLogoComponent {
    set scaling(val) {
      this._scaling = val;
      this.width = typeof val === 'number' ? val : undefined;
      this.matchHeight = typeof val === 'string' && val === 'match-height';
      this.matchWidth = typeof val === 'string' && val === 'match-width';
    }
    constructor(document, http) {
      this.background = false;
      this.outline = false;
      this.quad = false;
      this.width = undefined;
      this.matchHeight = false;
      this.matchWidth = false;
      this._scaling = 'match-width';
      const currHost = domainInfoToHostName(getCurrentDomainInfo(document.location.href));
      // fixed path, returned data can be overridden using our server utils, see @common/ssr!
      http.get('//' + currHost + '/assets/logo/logo.svg', {
        headers: new HttpHeaders({
          'Accept': 'image/svg+xml'
        }),
        responseType: 'text'
      }).subscribe({
        next: response => {
          this.logo = response;
        },
        error: err => {
          console.error('logo failed to load,', err);
        }
      });
    }
    static {
      this.ɵfac = function UiLogoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiLogoComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1.HttpClient));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiLogoComponent,
        selectors: [["ui-logo"]],
        hostVars: 6,
        hostBindings: function UiLogoComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width, "px");
            i0.ɵɵclassProp("match-height", ctx.matchHeight)("match-width", ctx.matchWidth);
          }
        },
        inputs: {
          background: "background",
          outline: "outline",
          quad: "quad",
          scaling: "scaling"
        },
        decls: 2,
        vars: 11,
        consts: [[3, "innerHTML", "ngClass"]],
        template: function UiLogoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
            i0.ɵɵpipe(1, "safeHtml");
          }
          if (rf & 2) {
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 2, ctx.logo), i0.ɵɵsanitizeHtml)("ngClass", i0.ɵɵpureFunction6(4, _c0, ctx.background, ctx.outline, ctx.quad, ctx.matchHeight, ctx.matchWidth, !ctx.matchWidth && !ctx.matchHeight));
          }
        },
        dependencies: [CommonModule, i2.NgClass, SafeHtmlPipe],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center}[_nghost-%COMP%]     svg{display:block}.default[_ngcontent-%COMP%]{width:100%}.default[_ngcontent-%COMP%]     svg{width:100%}.match-height[_nghost-%COMP%], .match-height[_nghost-%COMP%]   div[_ngcontent-%COMP%]{height:100%;width:100%}.match-height[_nghost-%COMP%]     svg{height:100%;width:auto}.match-width[_nghost-%COMP%], .match-width[_nghost-%COMP%]   div[_ngcontent-%COMP%]{width:100%}.match-width[_nghost-%COMP%]     svg{width:100%}.background[_ngcontent-%COMP%]{background:var(--logoBgColor);padding:0;display:inline-block;line-height:0}.background.quad[_ngcontent-%COMP%]{padding:0}.outline[_ngcontent-%COMP%]{border:2px solid #fff}\n\n/*# sourceMappingURL=logo.ts-angular-inline--14.css.map*/"]
      });
    }
  }
  return UiLogoComponent;
})();